import React, { useState } from "react";
// import "./style.css";
import classes from "./skaleBill.module.css";
// import { ReactComponent as SkalebotWhatsapp } from "../../../image/skalebotWhatsapp.svg";

import { ReactComponent as SkalebotLogo } from "../../../image/homePage/ourProducts/skaleBotIcon.svg";
import whatsappQrCodeSvg from "../../../image/productpages/whatsappQrCode.svg";
import appStoreSvg from "../../../image/productpages/AppStore.svg";
import playStoreSvg from "../../../image/productpages/PlayStore.svg";
import { useForm, Controller } from "react-hook-form";
import { InputText } from "primereact/inputtext";
import { classNames } from "primereact/utils";
import { introData } from "../../../data/OurProductsData/SkaleBotData/SkaleBotData";
import { videoData } from "../../../data/OurProductsData/SkaleBotData/SkaleBotData";
import { benifitsData } from "../../../data/OurProductsData/SkaleBotData/SkaleBotData";
import { MarketingData } from "../../../data/OurProductsData/SkaleBotData/SkaleBotData";
import InnerNav from "../../../components/InnerNav/InnerNav";
import SkaleBotCoverJPG from "../../../image/ProductsImages/SkaleBotCover.jpg";
import bannerPNG from "../../../image/ProductsImages/SkaleBotCover.jpg";
import { Form, Button } from "react-bootstrap";
import CustomModal from "../../../components/CustomModal/CustomModal";

const SkaleBill = () => {
  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => {
    setShowModal(true);
  };

  const handleHideModal = () => {
    setShowModal(false);
  };
  const itemslistnav = [
    { label: "SkaleWork", path: "skalework", url: "/products/skalework" },
    { label: "Skalebot", path: "skalebot", url: "/products/skalebot" },
    {
      label: "Stock Inventory",
      path: "stockinventory",
      url: "/products/stockinventory"
    },
    { label: "Skale Bill", path: "skalebill", url: "/products/skalebill" }
  ];

  const defaultValues = {
    name: "",
    email: ""
  };
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
    setValue,
    watch
  } = useForm({ defaultValues });

  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  const submithandler = (e) => {
    setValue("name", "");
    setValue("email", "");
  };

  return (
    <div className={` ${classes.mainContainer} gap-2 `}>
      {showModal && (
        <CustomModal
          title="Schedule A Demo"
          description="Do you have a question? We’re here to help you find the answers. Get in touch with us below."
          showModal={showModal}
          onHideModal={handleHideModal}
        />
      )}
      <div className={classes.innerNav}>
        <InnerNav itemslist={itemslistnav} />
      </div>
      <div className={`${classes.introContainer} `}>
        <div className={classes.leftIntro}>
          {/* <div className={classes.headingContainer}> */}
          <SkalebotLogo />
           <h2 className={classes.skalebotTitle}>SkaleBill </h2>
          <h2 className={classes.skalebotSubTitle}>
            The Smart Way of doing Business
          </h2>
          <p className={classes.skalebotContent}>
            Scale your  <b>B</b>usiness sales. <b>O</b>pportunities. <b>T</b>
            argets
          </p>
          <p className={classes.skalebotContent}>
            Trusted Sales Assistant to boost your Business
          </p>
          <div className={`${classes.buttonContainer} gap-2`}>
            <button className={`${classes.button} bg-white`}>
              VISIT WEBSITE
            </button>
            <button
              className={`${classes.button} bg-black text-white`}
              onClick={handleShowModal}
            >
              SCHEDULE DEMO
            </button>
          </div>
        </div>
        <div className={classes.rightIntro}>
          {/* <SkalebotWhatsapp /> */}
          <img src={SkaleBotCoverJPG} alt="skalebotCover" title="Skalebill logo" />
          {/* <img src={bannerPNG} alt="skalebotCover" /> */}
        </div>
      </div>

      <div className={classes.benifitsContainer}>
        <h2 className={classes.benifitsHeading}>
          What Will You get from this skalebot?
        </h2>
        <div className={`${classes.scrollableContainer}`}>
          <div className={`${classes.cardsContainer}`}>
            {benifitsData.map((item, index) => {
              return (
                <div key={index} className={classes.cardWraper}>
                  <div className={`${classes.customCard} gap-2`}>
                    <img src={item.image} alt={`item-${index}`} title="benifits images" />
                    <h3 className={classes.cardTitle}>{item.title}</h3>
                    <p className={classes.cardDescription}>
                      {item.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className={classes.videoContainer}>
        <h2 className={classes.videoTitle}>{videoData.title}</h2>
        <h3 className={classes.videoText}>{videoData.subTitle}</h3>
        <iframe
          width="560"
          height="315"
          src={videoData.videoSrc}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
        ></iframe>
      </div>

      <div className={classes.marketingContainer}>
        <h2 className={classes.marketingTitle}>MARKETING</h2>
        <div className={`${classes.scrollableContainer}`}>
          <div className={classes.cardsContainer}>
            {MarketingData.map((item, index) => {
              return (
                <div key={index} className={classes.cardWraper}>
                  <div className={`${classes.marketingCard}`}>
                    <div className={classes.marketingImage}>
                      <img
                        src={item.image}
                        alt="marketing"
                        title="Marketing image"
                        className={classes.marketingImage}
                      />
                    </div>
                    <p className={classes.publishBy}>{item.publishBy}</p>
                    <h3 className={classes.publishTitle}>
                      {item.publishTitle}
                    </h3>
                    <h3 className={`${classes.publishDescription}`}>
                      {item.publishDescription}
                    </h3>
                    <div className={`${classes.badgesContainer} gap-2`}>
                      <p className={`${classes.badges} rounded-pill`}>
                        {item.badges[0]}
                      </p>
                      <p className={`${classes.badges} rounded-pill`}>
                        {item.badges[1]}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
            {/* <div className={classes.cardWraper}>
            <div className={`${classes.marketingCard}`}>
              <div className={classes.marketingImage}>
                <img
                  src={marketingImageSVG}
                  alt="marketing"
                  className={classes.marketingImage}
                />
              </div>
              <p className={classes.publishBy}>Alec Whitten • 17 Jan 2022</p>
              <h3 className={classes.publishTitle}>
                Bill Walsh leadership lessons
              </h3>
              <h3
                className={`${classes.publishDescription} border border-warning`}
              >
                Like to know the secrets of transforming a 2-14 team into a 3x
                Super Bowl winning Dynasty?
              </h3>
              <div className={`${classes.badgesContainer} gap-2`}>
                <p className={`${classes.badges} rounded-pill`}>Leadership</p>
                <p className={`${classes.badges} rounded-pill`}>Managment</p>
              </div>
            </div>
          </div> */}
          </div>
        </div>
      </div>

      <div className={classes.whatsappContainer}>
        <img src={whatsappQrCodeSvg} alt="whatsappQrCodeSvg" />
        <div className={classes.qrDetails}>
           <h2 className={classes.qrTitle}>
            Catch our WhatsApp chatbot live in action!
           </h2>
           <h2 className={classes.qrSubTitle}>
            Scan the QR Code to experience our WhatsApp chatbot.
           </h2>
          <p className={classes.qrmobileTitle}>TRY SKALEBOT ON MOBILE</p>
          <div className={`${classes.storeContainer} gap-2`}>
            <img
              src={appStoreSvg}
              alt="appStoreSvg"
              title="App Store"
              className="cursor-pointer"
            />
            <img
              src={playStoreSvg}
              alt="playStore"
              title="Play Store"
              className="cursor-pointer"
            />
          </div>
        </div>
      </div>

      <div className={classes.contactUsContainer}>
         <h2 className={classes.contactUsTitle}>
          Learn more, arrange a call back!
         </h2>
        <div className={`${classes.formContainer} gap-2`}>
          <div className={classes.inputDiv}>
            <Controller
              name="name"
              control={control}
              rules={{ required: "Please provide name" }}
              render={({ field, fieldState }) => (
                <InputText
                  id={field.name}
                  // disabled={!edit && mode === "update"}
                  value={field.value}
                  onChange={(e) => field.onChange(e.target.value)}
                  //   useGrouping={false}
                  locale="en-IN"
                  placeholder="Your Name"
                  style={{
                    background: "transparent"
                  }}
                  // className={classNames(
                  //   classes.inputStyle,
                  //   " text-white  rounded-pill ",
                  //   {
                  //     "p-invalid": fieldState.invalid
                  //   }
                  // )}
                  className={`form-control   rounded-pill ${
                    classes.inputStyle
                  } ${fieldState.invalid ? "is-invalid" : ""}`}
                />
              )}
            />
            {getFormErrorMessage("name")}
          </div>
          <div className={classes.inputDiv}>
            <Controller
              name="email"
              control={control}
              rules={{ required: "Please provide email" }}
              render={({ field, fieldState }) => (
                <InputText
                  id={field.name}
                  // disabled={!edit && mode === "update"}
                  value={field.value}
                  onChange={(e) => field.onChange(e.target.value)}
                  //   useGrouping={false}
                  locale="en-IN"
                  placeholder="Your Email"
                  style={{
                    background: "transparent"
                  }}
                  // className={classNames(
                  //   classes.inputStyle,{`form-control ${fieldState.invalid ? "is-invalid" : ""}`}
                  //   " text-white   rounded-pill ",
                  //   {
                  //     "p-invalid": fieldState.invalid
                  //   }
                  // )}
                  className={`form-control   rounded-pill ${
                    classes.inputStyle
                  } ${fieldState.invalid ? "is-invalid" : ""}`}
                />
              )}
            />
            {getFormErrorMessage("email")}
          </div>
          <button
            className={classes.submitButton}
            onClick={handleSubmit(submithandler)}
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default SkaleBill;
